import {
  getImageBase64,
  getBackground,
  getThemePic,
} from "@/views/home/slidePPT/use/methods";
import { pathToBase64 } from "@/utils";

export default async function (data) {
  const node = data.node;
  const catalogueList = node.list || node.children;
  const color = data.color;
  let htmlText = "<ul>";
  for (let i = 0; i < catalogueList.length; i++) {
    const item = catalogueList[i];
    htmlText += `<li style=\"text-align: left;\"><span style=\"font-size: 24.49px;font-family: Microsoft Yahei;\">${item}</span></li>`;
  }
  htmlText += "</ul>";
  const id = Math.random().toString(36).slice(-8);
  const background = await getBackground(data?.customTheme);

  return {
    id: id,
    elements: [
      {
        type: "shape",
        id: "xDwibOTgxs",
        width: 532.38,
        height: 458.95,
        left: -81.56,
        top: 36.86,
        viewBox: [532.38, 458.95],
        path: "M 266.19 0 L 0 458.95 L 532.38 458.95 Z",
        fill: "rgba(255,255,255,1)",
        fixedRatio: false,
        rotate: 273,
        text: {
          content:
            '<p style="text-align: center;"><span style="font-size: 18.37px;font-family: Arial Narrow;">&nbsp;</span></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "rgba(244,244,244,1)",
          align: "middle",
        },
        flipH: false,
        flipV: false,
        pathFormula: "triangle",
        keypoint: 0.5,
        shadow: {
          h: 3,
          v: 3,
          blur: 15,
          color: "#808080",
        },
      },
      {
        type: "text",
        id: "d11BUdVIUf",
        width: 326.7903100224825,
        height: 68.984375,
        left: 100.93151065763251,
        top: 197.35062499999998,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "rgba(127,127,127,1)",
        content:
          '<p style="text-align: left;"><span style="font-size: 48.98px;font-family: Arial Narrow;font-weight: bold;">CONTENTS</span></p>',
        lineHeight: 1,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        fill: "",
        vertical: false,
      },
      {
        type: "line",
        id: "XLZ7FK7Bui",
        width: 0.5,
        left: 91.8,
        top: 229.91,
        start: [0, 0],
        end: [187.5, 0],
        style: "solid",
        color: "rgba(255,255,255,1)",
        points: ["", ""],
      },
      {
        type: "text",
        id: "byTAxIfMMD",
        width: 135.29,
        height: 56.734375,
        left: 184.63,
        top: 274.83500000000004,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "rgba(127,127,127,1)",
        content:
          '<p style="text-align: left;"><span style="font-size: 36.73px;font-family: Arial Narrow;font-weight: bold;">目录</span></p>',
        lineHeight: 1,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        fill: "",
        vertical: false,
      },
      {
        type: "shape",
        id: "UpX_zZB_FE",
        width: 312.41,
        height: 269.32,
        left: 726.61,
        top: -183.29,
        viewBox: [312.41, 269.32],
        path: "M 156.205 0 L 0 269.32 L 312.41 269.32 Z",
        fill: "rgba(255,255,255,1)",
        fixedRatio: false,
        rotate: 339,
        outline: {
          color: "#5B9BD5",
          width: 0,
          style: "solid",
        },
        text: {
          content:
            '<p style="text-align: center;"><span style="font-size: 18.37px;font-family: Arial Narrow;">&nbsp;</span></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "rgba(244,244,244,1)",
          align: "middle",
        },
        flipH: false,
        flipV: false,
        shadow: {
          h: 0.1,
          v: 1.88,
          blur: 38.54,
          color: "rgb(150, 150, 150)",
        },
        pathFormula: "triangle",
        keypoint: 0.5,
      },
      {
        type: "shape",
        id: "YzTr7MtJcA",
        width: 91.58,
        height: 78.95,
        left: 886.47,
        top: 447.06,
        viewBox: [91.58, 78.95],
        path: "M 45.79 0 L 0 78.95 L 91.58 78.95 Z",
        fill: "rgba(255,255,255,1)",
        fixedRatio: false,
        rotate: 265,
        outline: {
          color: "#5B9BD5",
          width: 0,
          style: "solid",
        },
        text: {
          content:
            '<p style="text-align: center;"><span style="font-size: 18.37px;font-family: Arial Narrow;">&nbsp;</span></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "rgba(244,244,244,1)",
          align: "middle",
        },
        flipH: false,
        flipV: false,
        shadow: {
          h: 0.1,
          v: 1.88,
          blur: 38.54,
          color: "rgb(150, 150, 150)",
        },
        pathFormula: "triangle",
        keypoint: 0.5,
      },
      {
        type: "text",
        id: "FKQsx5EgLg",
        left: 493.4541792547834,
        top: 137.23308734055047,
        width: 361.664988251091,
        height: 241.921875,
        content: htmlText,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#7f7f7f",
        vertical: false,
      },
    ],
    background,
  };
}
